import {
    METHOD_POST,
    SERVER_URL,
} from '../constants/api';
import { headersAuthSendReceiveJson } from '../headers';
import { apiHandleResponse } from '../../util/api';

const list = (options) => {
    return fetch(`${SERVER_URL}/api/v1/cms/analysis/executions`, {
        method: METHOD_POST,
        headers: headersAuthSendReceiveJson(),
        body: JSON.stringify(options),
    }).then(apiHandleResponse);
};

const stopExecution = (executionId) => {
    return fetch(`${SERVER_URL}/api/v1/cms/analysis/stop/${executionId}`, {
        method: METHOD_POST,
        headers: headersAuthSendReceiveJson(),
    }).then(apiHandleResponse);
};

const getClaimExecutionCount = (payload) => {
    return fetch(`${SERVER_URL}/api/v2/cms/analysis/count`, {
        method: METHOD_POST,
        headers: headersAuthSendReceiveJson(),
        body: JSON.stringify(payload),
    }).then(apiHandleResponse);
};

const executeClaims = (payload) => {
    return fetch(`${SERVER_URL}/api/v1/cms/analysis`, {
        method: METHOD_POST,
        headers: headersAuthSendReceiveJson(),
        body: JSON.stringify(payload),
    }).then(apiHandleResponse);
};

const downloadReportById = (id) => {
    return fetch(`${SERVER_URL}/api/v1/cms/analysis/report/${id}`, {
        method: METHOD_POST,
        headers: headersAuthSendReceiveJson(),
    }).then(apiHandleResponse);
};

const pricerExecutionList = (options) => {
    return fetch(`${SERVER_URL}/api/v2/cms/pricer/config/negotiatedrate/executions`, {
        method: METHOD_POST,
        headers: headersAuthSendReceiveJson(),
        body: JSON.stringify(options),
    }).then(apiHandleResponse);
};

const pricerStopExecution = (executionId) => {
    return fetch(`${SERVER_URL}/api/v2/cms/pricer/config/negotiatedrate/stop/${executionId}`, {
        method: METHOD_POST,
        headers: headersAuthSendReceiveJson(),
    }).then(apiHandleResponse);
};

const pricerExecuteClaims = (payload) => {
    return fetch(`${SERVER_URL}/api/v1/cms/pricer/analysis`, {
        method: METHOD_POST,
        headers: headersAuthSendReceiveJson(),
        body: JSON.stringify(payload),
    }).then(apiHandleResponse);
};

const pricerDownloadReportById = (id) => {
    return fetch(`${SERVER_URL}/api/v2/cms/pricer/config/negotiatedrate/report/${id}`, {
        method: METHOD_POST,
        headers: headersAuthSendReceiveJson(),
    }).then(apiHandleResponse);
};

const ediExecutionList = (options) => {
    return fetch(`${SERVER_URL}/api/v1/cms/pricer/edi/executions`, {
        method: METHOD_POST,
        headers: headersAuthSendReceiveJson(),
        body: JSON.stringify(options),
    }).then(apiHandleResponse);
};

export {
    list,
    stopExecution,
    getClaimExecutionCount,
    executeClaims,
    downloadReportById,
    pricerExecutionList,
    pricerStopExecution,
    pricerExecuteClaims,
    pricerDownloadReportById,
    ediExecutionList
};